// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Alert = require("../common/Components/Alert.bs.js");
let React = require("react");
let ButtonsV5 = require("../common/Components/ButtonsV5.bs.js");
let Formality = require("@tan/formality/src/Formality.bs.js");
let FormalityUI = require("../common/Components/FormalityUI.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Form__TextInput = require("../common/Components/Form__TextInput.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let UnifiedProfileSave = require("./UnifiedProfileSave.bs.js");
let Formality__ReactUpdate = require("@tan/formality/src/Formality__ReactUpdate.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let UnifiedProfileSettingsUI = require("./UnifiedProfileSettingsUI.bs.js");
let UnifiedYourProfileProfessionalInformationForm_agent_graphql = require("../../__generated__/UnifiedYourProfileProfessionalInformationForm_agent_graphql.bs.js");
let UnifiedYourProfileProfessionalInformationFormBrokerageMutation_graphql = require("../../__generated__/UnifiedYourProfileProfessionalInformationFormBrokerageMutation_graphql.bs.js");

let convertVariables = UnifiedYourProfileProfessionalInformationFormBrokerageMutation_graphql.Internal.convertVariables;

let convertResponse = UnifiedYourProfileProfessionalInformationFormBrokerageMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = UnifiedYourProfileProfessionalInformationFormBrokerageMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, UnifiedYourProfileProfessionalInformationFormBrokerageMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use = RescriptRelay_Mutation.useMutation(convertVariables, UnifiedYourProfileProfessionalInformationFormBrokerageMutation_graphql.node, convertResponse, convertWrapRawResponse);

let BrokerageMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

function usePersonalBrokerage() {
  let match = use();
  let commit = match[0];
  return UnifiedProfileSave.useAccountSave(match[1], (input, onCompleted, onError) => commit({
    input: input
  }, undefined, undefined, undefined, onCompleted, onError, undefined), response => {
    let match = response.updateUnifiedBrokerage;
    if (match === undefined) {
      return {
        TAG: "Error",
        _0: "Your changes could not be saved. Please try again."
      };
    }
    switch (match.__typename) {
      case "UnifiedPersonalProfileUpdated" :
        return {
          TAG: "Ok",
          _0: undefined
        };
      case "UnifiedProfileUpdateFailed" :
        return {
          TAG: "Error",
          _0: match.message
        };
      case "__unselected" :
        return {
          TAG: "Error",
          _0: "Your changes could not be saved. Please try again."
        };
    }
  });
}

let validators_brokerage = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: param => {
    let brokerage = param.brokerage.trim();
    if (brokerage === "") {
      return {
        TAG: "Error",
        _0: "is required"
      };
    } else {
      return {
        TAG: "Ok",
        _0: brokerage
      };
    }
  }
};

let validators = {
  brokerage: validators_brokerage,
  licenseNumber: undefined
};

function initialFieldsStatuses(input) {
  return {
    brokerage: "Pristine",
    licenseNumber: "Pristine"
  };
}

function initialFieldStatuses_xxx(x) {
  return {
    brokerage: "Pristine",
    licenseNumber: "Pristine"
  };
}

function initialState(input) {
  return {
    input: input,
    fieldsStatuses: {
      brokerage: "Pristine",
      licenseNumber: "Pristine"
    },
    collectionsStatuses: undefined,
    formStatus: "Editing",
    submissionStatus: "NeverSubmitted"
  };
}

function validateForm(input, validators, fieldsStatuses) {
  let match = fieldsStatuses.brokerage;
  let tmp;
  tmp = typeof match !== "object" ? validators.brokerage.validate(input) : match._0;
  let match_0 = {
    TAG: "Ok",
    _0: input.licenseNumber
  };
  let brokerageResult = tmp;
  let brokerageResult$1;
  if (brokerageResult.TAG === "Ok") {
    let licenseNumberResult = match_0;
    if (licenseNumberResult.TAG === "Ok") {
      return {
        TAG: "Valid",
        output: {
          brokerage: brokerageResult._0,
          licenseNumber: licenseNumberResult._0
        },
        fieldsStatuses: {
          brokerage: {
            TAG: "Dirty",
            _0: brokerageResult,
            _1: "Shown"
          },
          licenseNumber: {
            TAG: "Dirty",
            _0: licenseNumberResult,
            _1: "Hidden"
          }
        },
        collectionsStatuses: undefined
      };
    }
    brokerageResult$1 = brokerageResult;
  } else {
    brokerageResult$1 = brokerageResult;
  }
  return {
    TAG: "Invalid",
    fieldsStatuses: {
      brokerage: {
        TAG: "Dirty",
        _0: brokerageResult$1,
        _1: "Shown"
      },
      licenseNumber: {
        TAG: "Dirty",
        _0: match_0,
        _1: "Hidden"
      }
    },
    collectionsStatuses: undefined
  };
}

function useForm(initialInput, onSubmit) {
  let memoizedInitialState = React.useMemo(() => initialState(initialInput), [initialInput]);
  let match = Formality__ReactUpdate.useReducer(memoizedInitialState, (state, action) => {
    if (typeof action !== "object") {
      switch (action) {
        case "BlurBrokerageField" :
          let result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.brokerage, validators_brokerage, status => {
            let init = state.fieldsStatuses;
            return {
              brokerage: status,
              licenseNumber: init.licenseNumber
            };
          });
          if (result !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurLicenseNumberField" :
          let result$1 = Formality.validateFieldOnBlurWithoutValidator(state.input.licenseNumber, state.fieldsStatuses.licenseNumber, status => {
            let init = state.fieldsStatuses;
            return {
              brokerage: init.brokerage,
              licenseNumber: status
            };
          });
          if (result$1 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$1,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "Submit" :
          let match = state.formStatus;
          if (typeof match === "object" && match.TAG === "Submitting") {
            return "NoUpdate";
          }
          let match$1 = validateForm(state.input, validators, state.fieldsStatuses);
          if (match$1.TAG !== "Valid") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: match$1.fieldsStatuses,
                collectionsStatuses: match$1.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: "AttemptedToSubmit"
              }
            };
          }
          let output = match$1.output;
          let error = state.formStatus;
          let tmp;
          tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : error._0;
          return {
            TAG: "UpdateWithSideEffects",
            _0: {
              input: state.input,
              fieldsStatuses: match$1.fieldsStatuses,
              collectionsStatuses: match$1.collectionsStatuses,
              formStatus: {
                TAG: "Submitting",
                _0: tmp
              },
              submissionStatus: "AttemptedToSubmit"
            },
            _1: param => {
              let dispatch = param.dispatch;
              onSubmit(output, {
                notifyOnSuccess: input => dispatch({
                  TAG: "SetSubmittedStatus",
                  _0: input
                }),
                notifyOnFailure: error => dispatch({
                  TAG: "SetSubmissionFailedStatus",
                  _0: error
                }),
                reset: () => dispatch("Reset"),
                dismissSubmissionResult: () => dispatch("DismissSubmissionResult")
              });
            }
          };
          break;
        case "DismissSubmissionError" :
          let match$2 = state.formStatus;
          if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
            return "NoUpdate";
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "DismissSubmissionResult" :
          let match$3 = state.formStatus;
          if (typeof match$3 !== "object") {
            if (match$3 === "Editing") {
              return "NoUpdate";
            }
          } else if (match$3.TAG === "Submitting") {
            return "NoUpdate";
          }
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: "Editing",
              submissionStatus: state.submissionStatus
            }
          };
        case "Reset" :
          return {
            TAG: "Update",
            _0: initialState(initialInput)
          };
      }
    } else {
      switch (action.TAG) {
        case "UpdateBrokerageField" :
          let nextInput = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.brokerage, state.submissionStatus, validators_brokerage, status => {
                let init = state.fieldsStatuses;
                return {
                  brokerage: status,
                  licenseNumber: init.licenseNumber
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateLicenseNumberField" :
          let nextInput$1 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$1,
              fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$1.licenseNumber, status => {
                let init = state.fieldsStatuses;
                return {
                  brokerage: init.brokerage,
                  licenseNumber: status
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "SetSubmittedStatus" :
          let input = action._0;
          if (input !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: input,
                fieldsStatuses: {
                  brokerage: "Pristine",
                  licenseNumber: "Pristine"
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: {
                  brokerage: "Pristine",
                  licenseNumber: "Pristine"
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "SetSubmissionFailedStatus" :
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: {
                TAG: "SubmissionFailed",
                _0: action._0
              },
              submissionStatus: state.submissionStatus
            }
          };
        case "MapSubmissionError" :
          let map = action._0;
          let error$1 = state.formStatus;
          if (typeof error$1 !== "object") {
            return "NoUpdate";
          }
          if (error$1.TAG !== "Submitting") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "SubmissionFailed",
                  _0: map(error$1._0)
                },
                submissionStatus: state.submissionStatus
              }
            };
          }
          let error$2 = error$1._0;
          if (error$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "Submitting",
                  _0: map(error$2)
                },
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
      }
    }
  });
  let dispatch = match[1];
  let state = match[0];
  let match$1 = state.formStatus;
  let tmp;
  tmp = typeof match$1 !== "object" ? false : match$1.TAG === "Submitting";
  return {
    updateBrokerage: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateBrokerageField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateLicenseNumber: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateLicenseNumberField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    blurBrokerage: () => dispatch("BlurBrokerageField"),
    blurLicenseNumber: () => dispatch("BlurLicenseNumberField"),
    brokerageResult: Formality.exposeFieldResult(state.fieldsStatuses.brokerage),
    licenseNumberResult: Formality.exposeFieldResult(state.fieldsStatuses.licenseNumber),
    input: state.input,
    status: state.formStatus,
    dirty: () => {
      let match = state.fieldsStatuses;
      let tmp = match.brokerage;
      if (typeof tmp === "object") {
        return true;
      }
      let tmp$1 = match.licenseNumber;
      return typeof tmp$1 === "object";
    },
    valid: () => {
      let match = validateForm(state.input, validators, state.fieldsStatuses);
      return match.TAG === "Valid";
    },
    submitting: tmp,
    submit: () => dispatch("Submit"),
    dismissSubmissionError: () => dispatch("DismissSubmissionError"),
    dismissSubmissionResult: () => dispatch("DismissSubmissionResult"),
    mapSubmissionError: map => dispatch({
      TAG: "MapSubmissionError",
      _0: map
    }),
    reset: () => dispatch("Reset")
  };
}

let FormConfig = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialFieldStatuses_xxx: initialFieldStatuses_xxx,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

let convertFragment = UnifiedYourProfileProfessionalInformationForm_agent_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, UnifiedYourProfileProfessionalInformationForm_agent_graphql.node, convertFragment, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(UnifiedYourProfileProfessionalInformationForm_agent_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, UnifiedYourProfileProfessionalInformationForm_agent_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(UnifiedYourProfileProfessionalInformationForm_agent_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use$1,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function UnifiedYourProfileProfessionalInformationForm(props) {
  let agent = RescriptRelay_Fragment.useFragment(UnifiedYourProfileProfessionalInformationForm_agent_graphql.node, convertFragment, props.agent);
  let match = UnifiedProfileSave.usePersonalProfessionalInfo();
  let saveProfessionalInfo = match[0];
  let match$1 = usePersonalBrokerage();
  let saveBrokerage = match$1[0];
  let saving = match[1] || match$1[1];
  let form = useForm({
    brokerage: Stdlib_Option.getOr(agent.brokerage, ""),
    licenseNumber: Stdlib_Option.getOr(agent.licenseNumber, "")
  }, (values, param) => {
    let notifyOnFailure = param.notifyOnFailure;
    let notifyOnSuccess = param.notifyOnSuccess;
    saveProfessionalInfo({
      licenseNumber: values.licenseNumber
    }, () => saveBrokerage({
      brokerage: values.brokerage
    }, () => notifyOnSuccess(undefined), message => notifyOnFailure("License number saved. Brokerage save could not be confirmed. Use Save to retry. " + message)), message => notifyOnFailure(message));
  });
  React.useEffect(() => {
    let match = form.status;
    if (typeof match !== "object") {
      if (match !== "Editing") {
        form.dismissSubmissionResult();
      }
    } else if (match.TAG !== "Submitting") {
      form.dismissSubmissionResult();
    }
  }, [form.input]);
  let message = form.status;
  let tmp;
  tmp = typeof message !== "object" ? (
      message === "Editing" ? null : JsxRuntime.jsx(Alert.Success.make, {
          title: "Account updated"
        })
    ) : (
      message.TAG === "Submitting" ? null : JsxRuntime.jsx(Alert.$$Error.make, {
          title: message._0
        })
    );
  return JsxRuntime.jsxs("form", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("h3", {
                children: "Professional Information",
                className: "text-lg font-semibold leading-7 text-gray-900"
              }),
              JsxRuntime.jsx("div", {
                children: tmp,
                role: "status"
              })
            ],
            className: "space-y-4 sm:py-6"
          }),
          JsxRuntime.jsxs(UnifiedProfileSettingsUI.FormField.make, {
            label: "Brokerage",
            children: [
              JsxRuntime.jsx(Form__TextInput.make, {
                type: "text",
                onChange: event => form.updateBrokerage((input, value) => ({
                  brokerage: value,
                  licenseNumber: input.licenseNumber
                }), event.target.value),
                onBlur: param => form.blurBrokerage(),
                status: Stdlib_Option.map(form.brokerageResult, result => {
                  if (result.TAG === "Ok") {
                    return "ok";
                  } else {
                    return "error";
                  }
                }),
                value: form.input.brokerage
              }),
              JsxRuntime.jsx(FormalityUI.FieldValidationMessage.make, {
                messageToString: message => message,
                result: form.brokerageResult
              })
            ]
          }),
          JsxRuntime.jsx(UnifiedProfileSettingsUI.FormField.make, {
            label: "License number",
            children: JsxRuntime.jsx(Form__TextInput.make, {
              type: "text",
              onChange: event => form.updateLicenseNumber((input, value) => ({
                brokerage: input.brokerage,
                licenseNumber: value
              }), event.target.value),
              onBlur: param => form.blurLicenseNumber(),
              value: form.input.licenseNumber
            })
          })
        ],
        className: "space-y-8 border-b border-zinc-200 pb-12 sm:space-y-0 sm:divide-y sm:divide-zinc-200 sm:pb-0"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
          disabled: saving || form.submitting,
          children: "Save"
        })
      })
    ],
    className: "space-y-8",
    onSubmit: event => {
      event.preventDefault();
      form.submit();
    }
  });
}

let make = UnifiedYourProfileProfessionalInformationForm;

exports.BrokerageMutation = BrokerageMutation;
exports.usePersonalBrokerage = usePersonalBrokerage;
exports.FormConfig = FormConfig;
exports.Fragment = Fragment;
exports.make = make;
/* commitMutation Not a pure module */
